<template>
    <component :is="currentComponent"></component>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { Howl, Howler } from 'howler'
import { mapGetters, mapActions } from 'vuex'
import Desktop from './Desktop'
import Mobile from './Mobile'
import { Constants } from './constants'

const STANDBY_AUDIO_VOLUME = 0.2

export default {
    components: {
        Desktop, Mobile
    },
    props: {
        auctionId: {
            required: true,
        },
        locale: {
            required: true,
        },
        currency: {
            required: true
        },
    },
    data () {
        return {
            loading: true,
            standbyMusic: null,
        }
    },
    computed: {
        ...mapGetters({
            auction: 'getAuction',
            user: 'getUser',
            lot: 'getLot',
            lots: 'getLots',
            bidders: 'getBidders',
            bids: 'getBids',
            winner: 'getWinner',
            timer: 'getTimer',
            audioEnabled: 'getAudioEnabled',
        }),
        currentComponent() {
            return this.$isMobile() ? 'Mobile' : 'Desktop';
        },
        auctionStatus() {
            if (!this.auction) {
                return null
            }

            return this.auction.s
        },
        shouldPlayStandbyMusic() {
            return this.auctionStatus == Constants.AUCTION_LIVE_STATUS_STANDBY && this.supportsTimedTtsMode()
        },
    },
    watch: {
        auctionStatus() {
            this.syncStandbyMusic()
        },
        audioEnabled() {
            this.syncStandbyMusic()
        },
    },
    methods: {
        ...mapActions({
            'loadUser': 'loadUser',
            'loadAuction': 'loadAuction',
            'loadLots': 'loadLots',
            'loadLot': 'loadLot',
            'initializeAudio': 'initializeAudio',
        }),
        initializeStandbyMusic() {
            if (this.standbyMusic) {
                return
            }

            this.standbyMusic = new Howl({
                src: ['/live/sounds/auction.mp3', '/live/sounds/auction.ogg'],
                loop: true,
                volume: STANDBY_AUDIO_VOLUME,
                onplay: () => {
                    this.$store.commit('SET_AUDIO_BLOCKED', false)
                },
                onplayerror: (id, error) => {
                    this.handleStandbyMusicError(error)
                },
                onloaderror: (id, error) => {
                    this.handleStandbyMusicError(error)
                },
            })
        },
        async syncStandbyMusic() {
            if (!this.standbyMusic) {
                return
            }

            if (!this.shouldPlayStandbyMusic) {
                this.stopStandbyMusic()

                return
            }

            if (this.standbyMusic.playing()) {
                this.standbyMusic.volume(STANDBY_AUDIO_VOLUME)

                return
            }

            try {
                if (Howler.ctx && Howler.ctx.state === 'suspended') {
                    await Howler.ctx.resume()
                }
            } catch (error) {

            }

            this.standbyMusic.volume(STANDBY_AUDIO_VOLUME)
            this.standbyMusic.play()
        },
        stopStandbyMusic() {
            if (!this.standbyMusic) {
                return
            }

            this.standbyMusic.stop()
        },
        handleStandbyMusicError(error) {
            if (!this.shouldPlayStandbyMusic) {
                return
            }

            console.warn('[standby-audio] playback-error', error)
            this.stopStandbyMusic()
            this.$store.commit('SET_AUDIO_BLOCKED', true)
        },
        supportsTimedTtsMode() {
            if (!this.auction) {
                return false
            }

            return [4, 5].includes(Number(this.auction.md))
        },
        setupPusher() {

            Echo.connector.pusher.connection.bind('initialized', () => {
                console.log('initialized');
            });

            Echo.connector.pusher.connection.bind('connecting', () => {
                console.log('connecting');
            });

            Echo.connector.pusher.connection.bind('connected', () => {
                console.log('connected');
            });

            Echo.connector.pusher.connection.bind('unavailable', () => {
                console.log('unavailable');
            });

            Echo.connector.pusher.connection.bind('failed', () => {
                console.log('failed');
            });

            Echo.connector.pusher.connection.bind('disconnected', () => {
                console.log('disconnected');
            });

            Echo.connector.pusher.connection.bind('error', (error) => {
                console.log('error', error);
            });

            Echo.connector.pusher.connection.bind('state_change', (states) => {
                console.log('error', states);
            });

            if(this.user && this.user.approval_status == 2) {

                window.auctionPresenceChannel = Echo.join(`auction.${this.auction.id}`)

                auctionPresenceChannel

                    .here((members) => {

                    })

                    .joining((member) => {

                    })

                    .leaving((member) => {

                    })

                    .error((error) => {

                    });

                Echo.encryptedPrivate(`bidders.auction.${this.auction.id}`)

                    .listen('.lot.announce', (e) => {
                        this.$store.dispatch('resetMessages');
                        this.$store.dispatch('receiveAnnounceLot', e)

                        if(e.rcl == true) {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_announce_recall',
                                params: e,
                            });
                        } else if(e.bta == true) {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_announce_back_to_auction',
                                params: e,
                            });
                        }   else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_announce',
                                params: e,
                            });
                        }
                    })

                    .listen('.lot.open', (e) => {
                        this.$store.dispatch('receiveOpenBidding', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_open',
                            params: e,
                        });
                        if(e.w && Object.keys(e.w).length > 0) {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_open_winner',
                                params: e.w,
                            });
                        }
                    })

                    .listen('.lot.reserve', (e) => {
                        this.$store.dispatch('receiveOpenBidding', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_reserve',
                            params: e,
                        });
                    })

                    .listen('.lot.sell', (e) => {
                        if(this.user && this.user.id && e.w && e.w.uid == this.user.id) {
                            congrats.play()
                            this.$store.dispatch('addMessage', {
                                message: 'lot_sell_congrats',
                                params: e,
                            });
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_sell',
                                params: e,
                            });
                        }
                        this.$store.dispatch('receiveSellLot', e)
                    })

                    .listen('.lot.pass', (e) => {
                        this.$store.dispatch('receivePassLot', e)
                        if(e.p > 0 && e.p < e.r) {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_pass_reserve',
                                params: e,
                            });
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_pass',
                                params: e,
                            });
                        }
                    })

                    .listen('.lot.reset', (e) => {
                        this.$store.dispatch('receiveResetLot', e)
                        /*
                        this.$store.dispatch('addMessage', {
                            message: 'lot_reset',
                            params: e,
                        });
                        */
                    })

                    .listen('.bid.win', (e) => {
                        if(e.lid != this.lot.id) {
                            return;
                        }

                        if(this.user && this.user.id && e.uid == this.user.id) {
                            this.$notify({
                                text: this.$t('bids.highest', {'value': e.a}),
                                type: 'success',
                            })
                            highest.play()
                            this.$store.dispatch('addMessage', {
                                message: 'bid_win_congrats',
                                params: e,
                            });
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'bid_win',
                                params: e,
                            });
                        }
                        if(this.user && this.user.id && e.uid != this.user.id && this.winner && this.winner.uid == this.user.id) {
                            this.$notify({
                                text: this.$t('bids.outbid'),
                                type: 'error',
                            })
                            outbid.play()
                            this.$store.dispatch('addMessage', {
                                message: 'bid_outbid',
                                params: e,
                            });
                        }
                        this.$store.dispatch('receiveWinPaddle', e)
                    })

                    .listen('.price.changed', (e) => {
                        this.$store.dispatch('receivePriceChanged', e)
                        this.$store.dispatch('addMessage', {
                            message: 'price_changed',
                            params: e,
                        });
                    })

                    .listen('.ask.changed', (e) => {
                        if(this.lot.k > e.k) {
                            this.$store.dispatch('addMessage', {
                                message: 'ask_spit',
                                params: e,
                            });
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'ask_changed',
                                params: e,
                            });                        
                        }

                        this.$store.dispatch('receiveAskChanged', e);
                    })

                    .listen('.winner.changed', (e) => {
                        if(this.user && this.user.id && e.uid != this.user.id && this.winner && this.winner.uid == this.user.id) {
                            this.$notify({
                                text: this.$t('bids.outbid'),
                                type: 'error',
                            })
                            outbid.play()
                            this.$store.dispatch('addMessage', {
                                message: 'bid_outbid',
                                params: e,
                            });
                        }
                        this.$store.dispatch('receiveWinnerChanged', e);
                        this.$store.dispatch('addMessage', {
                            message: 'bid_win',
                            params: e,
                        });
                    })

                    .listen('.bid.receive', (e) => {

                        if(e.lid != this.lot.id) {
                            return;
                        }

                        if(this.user && this.user.id && e.uid == this.user.id) {
                            this.$notify({
                                text: this.$t('bids.received', {'value': this.lot.k}),
                                type: 'success',
                            })
                        }

                        this.$store.dispatch('bidReceive', e)
                        
                        this.$store.dispatch('addMessage', {
                            message: 'bid_receive',
                            params: e,
                        });
                        ding.play()
                    })

                    .listen('.absentee.receive', (e) => {
                        this.$store.dispatch('absenteeReceive', e)
                        ding.play()
                    })

                    .listen('.message', (e) => {
                        this.$store.dispatch('receiveMessage', e)
                    })

                    .listen('.auction.status', (e) => {
                        this.$store.dispatch('receiveUpdateAuctionStatus', e)
                    })

                    .listen('.stream.changed', (e) => {
                        this.$store.dispatch('receiveStreamChanged', e)
                    })

                    .listen('.auction.message', (e) => {
                        this.$store.dispatch('receiveUpdateAuctionStatus', e)
                    })

                    .listen('.announcement.audio', (e) => {
                        if (!this.supportsTimedTtsMode()) {
                            console.log('[announcement-audio] ignored', {
                                reason: 'auction-mode-not-supported',
                                auction: this.auction,
                                announcement: e,
                            })
                            return
                        }

                        this.$store.dispatch('receiveAudioAnnouncement', e)
                    })

                    .listen('.lot.warn', (e) => {
                        this.$store.dispatch('receiveWarn', e)
                        if(e.t) {
                            this.$store.dispatch('addMessage', {
                                message: `lot_warn_${e.t}`,
                                params: e,
                            });
                            if (e.t == 'sniper') {
                                if(! e.p) return;

                                this.$store.dispatch('setTimer', e.p / 10)
                            }   
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_warn',
                                params: e,
                            });
                        }
                    })

                    // .listen('.lot.postpone', (e) => {
                    //     this.$store.commit('INCREASE_TIMER', e.seconds)
                    // })

                    .listen('.lot.recall', (e) => {
                        this.$store.dispatch('receiveRecallLot', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_recall',
                            params: e,
                        });
                    })

                    .listen('.sync.reserve', (e) => {
                        this.$store.dispatch('receiveSyncReserve', e)
                    })

            } else {

                window.auctionPresenceChannel = false

                Echo.channel(`guests.auction.${this.auction.id}`)

                    .listen('.lot.announce', (e) => {
                        this.$store.dispatch('receiveAnnounceLot', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_announce',
                            params: e,
                        });
                        this.$store.dispatch('resetMessages');
                    })

                    .listen('.lot.open', (e) => {
                        this.$store.dispatch('receiveOpenBidding', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_open',
                            params: e,
                        });
                    })

                    .listen('.lot.reserve', (e) => {
                        this.$store.dispatch('receiveOpenBidding', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_reserve',
                            params: e,
                        });
                    })

                    .listen('.lot.sell', (e) => {
                        this.$store.dispatch('receiveSellLot', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_sell',
                            params: e,
                        });
                    })

                    .listen('.lot.pass', (e) => {
                        this.$store.dispatch('receivePassLot', e)
                        if(e.p > 0 && e.p < e.r) {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_pass_reserve',
                                params: e,
                            });
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_pass',
                                params: e,
                            });
                        }
                    })

                    .listen('.lot.reset', (e) => {
                        this.$store.dispatch('receiveResetLot', e)
                    })

                    .listen('.bid.win', (e) => {
                        if(e.lid != this.lot.id) {
                            return;
                        }

                        this.$store.dispatch('receiveWinPaddle', e)
                        this.$store.dispatch('addMessage', {
                            message: 'bid_win',
                            params: e,
                        });
                    })

                    .listen('.price.changed', (e) => {
                        this.$store.dispatch('receivePriceChanged', e)
                        this.$store.dispatch('addMessage', {
                            message: 'price_changed',
                            params: e,
                        });
                    })

                    .listen('.ask.changed', (e) => {
                        this.$store.dispatch('receiveAskChanged', e);
                        this.$store.dispatch('addMessage', {
                            message: 'ask_changed',
                            params: e,
                        });
                    })

                    .listen('.winner.changed', (e) => {
                        this.$store.dispatch('receiveWinnerChanged', e);
                        this.$store.dispatch('addMessage', {
                            message: 'bid_win',
                            params: e,
                        });
                    })

                    .listen('.bid.receive', (e) => {
                        if(e.lid != this.lot.id) {
                            return;
                        }
                        
                        this.$store.dispatch('bidReceive', e)
                        ding.play()
                        this.$store.dispatch('addMessage', {
                            message: 'bid_receive',
                            params: e,
                        });
                    })

                    .listen('.absentee.receive', (e) => {
                        this.$store.dispatch('absenteeReceive', e)
                        ding.play()
                    })

                    .listen('.message', (e) => {
                        this.$store.dispatch('receiveMessage', e)
                    })

                    .listen('.auction.status', (e) => {
                        this.$store.dispatch('receiveUpdateAuctionStatus', e)
                    })

                    .listen('.stream.changed', (e) => {
                        this.$store.dispatch('receiveStreamChanged', e)
                    })
                    
                    .listen('.auction.message', (e) => {
                        this.$store.dispatch('receiveUpdateAuctionStatus', e)
                    })

                    .listen('.announcement.audio', (e) => {
                        if (!this.supportsTimedTtsMode()) {
                            console.log('[announcement-audio] ignored', {
                                reason: 'auction-mode-not-supported',
                                auction: this.auction,
                                announcement: e,
                            })
                            return
                        }

                        this.$store.dispatch('receiveAudioAnnouncement', e)
                    })

                    .listen('.lot.warn', (e) => {
                        this.$store.dispatch('receiveWarn', e)
                        if(e.t) {
                            this.$store.dispatch('addMessage', {
                                message: `lot_warn_${e.t}`,
                                params: e,
                            });
                            if (e.t == 'sniper') {
                                if(! e.p) return;
                                
                                this.$store.dispatch('setTimer', e.p / 10)
                            }
                        } else {
                            this.$store.dispatch('addMessage', {
                                message: 'lot_warn',
                                params: e,
                            });
                        }
                    })

                    .listen('.lot.postpone', (e) => {
                        this.$store.commit('INCREASE_TIMER', e.seconds)
                    })

                    .listen('.lot.recall', (e) => {
                        this.$store.dispatch('receiveRecallLot', e)
                        this.$store.dispatch('addMessage', {
                            message: 'lot_recall',
                            params: e,
                        });
                    })

                    .listen('.sync.reserve', (e) => {
                        this.$store.dispatch('receiveSyncReserve', e)
                    })
            }
        }
    },
    async mounted () {
        axios.defaults.headers.common["Language"] = this.locale
        axios.defaults.headers.common["Accept-Language"] = this.locale
        this.$root.$i18n.locale = this.locale;

        this.$store.commit('SET_LOCALE', this.locale)
        this.$store.commit('SET_CURRENCY', this.currency)
        await this.initializeAudio()
        this.initializeStandbyMusic()
        await this.loadUser()
        await this.loadAuction(this.auctionId)
        this.setupPusher();
        await this.loadLots(this.auctionId);
        await this.loadLot(this.auctionId);
        this.$store.commit('SET_LOADING', false);
        await this.syncStandbyMusic()

        if(this.user && this.user.id) {
            Sentry.setUser({
                id: this.user.id,
                username: this.user.paddle
            });
        } else {
            Sentry.setUser(null);
        }
    },
    beforeDestroy () {
        this.stopStandbyMusic()

        if (this.standbyMusic) {
            this.standbyMusic.unload()
            this.standbyMusic = null
        }
    }
}
</script>
